import debounce from 'debounce'
import { useEffect, useState } from 'react'

interface Size {
  width: number | undefined
  height: number | undefined
}
//Based off https://usehooks.com/useWindowSize/

export function useWindowSize(): Size {
  const [windowSize, setWindowSize] = useState<Size>({
    width: undefined,
    height: undefined,
  })

  const handleResize = () =>
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    })

  useEffect(() => {
    const handleResizeDebounced = debounce(handleResize, 100)

    window.addEventListener('resize', handleResizeDebounced)

    handleResize()

    return () => {
      handleResizeDebounced.clear()
      window.removeEventListener('resize', handleResizeDebounced)
    }
  }, [])

  return windowSize
}
